import { CustomField } from "./customField";
import { CustomFieldParams } from "@/types/customFieldTypes";

export class StringCustomField extends CustomField {
  constructor(data: CustomFieldParams) {
    super(data);
  }

  hasValidDefaultInput() {
    return typeof this.defaultValue === "string";
  }

  hasValidCustomInput() {
    return typeof this.customValue === "string";
  }
}
